import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'zod';
import AuthLayout from '../../components/AuthLayout';
import { useToast } from '../../components/common/ToasterContext';
import ForgotPasswordComponent from '../../components/ForgotPassword';
import getAPIUrl from '../../config';
import postApi from '../../utils/apiCalls';
import { trimFormData } from '../../utils/helpers';

const ForgotPassword = () => {
    const [showError, setShowError] = useState<boolean>(false);
    const forgotPassValidationSchema = object({
        email: string().email({ message: 'Please provide a valid email address' }),
    });

    const [forgotPassValues, setForgotPassValues] = useState<{ email: string }>({
        email: '',
    });
    const [submitting, setSubmitting] = useState<boolean>(false);

    const toast = useToast();
    const navigate = useNavigate();

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validate = forgotPassValidationSchema.safeParse(trimFormData(forgotPassValues));
        if (validate.success) {
            setShowError(false);
            setSubmitting(true);
            try {
                await postApi(`${getAPIUrl()}/admins/reset-password`, forgotPassValues);
                if (toast) {
                    toast.onToggleSnackbar();
                    toast.onMessage('Request Processeed');
                    toast.onSuccess();
                }
                navigate('/');
            } catch (error: any) {
                setShowError(true);
                if (toast) {
                    toast.onToggleSnackbar();
                    toast.onMessage(error.response.data.errors);
                    toast.onError();
                }
                setForgotPassValues({
                    email: '',
                });
            } finally {
                setSubmitting(false);
            }
        } else {
            setShowError(true);
            setForgotPassValues({
                email: '',
            });
        }
    };

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value, name } = e.currentTarget;
        setForgotPassValues({
            ...forgotPassValues,
            [name]: value,
        });
    };

    return (
        <AuthLayout
            component={
                <ForgotPasswordComponent
                    handleSubmit={onSubmit}
                    showError={showError}
                    handleInput={handleInput}
                    credentials={forgotPassValues}
                    submitting={submitting}
                />
            }
        />
    );
};
export default ForgotPassword;
